import { RouteRecordRaw } from "vue-router";
import AuthMiddleware from "@/router/middleware/AuthMiddleware";
import UserAuthMiddleware from "@/router/middleware/UserAuthMiddleware";
import { ModuleList } from "@/models/settings/ModuleList";
import { PermissionList } from "@/models/settings/PermissionList";
import ModuleMiddleware from "@/router/middleware/ModuleMiddleware";

const moduleZewRoutings: Array<RouteRecordRaw> = [
	{
		name: "zew",
		path: "modules/zew",
		component: () => import("@/views/modules/zeitwirtschaft/TimeManagementPage.vue"),
		meta: {
			middleware: [new AuthMiddleware(), new UserAuthMiddleware(ModuleList.TIME_MANAGEMENT, PermissionList.MODULE_ZEW)],
		},
	},
	/*----- absences-----*/
	{
		name: "absences",
		path: "modules/zew/absences",
		component: () => import("@/views/modules/zeitwirtschaft/absences/AbsencePage.vue"),
		meta: {
			middleware: [
				new AuthMiddleware(),
				new ModuleMiddleware(ModuleList.TIME_MANAGEMENT),
				new UserAuthMiddleware(ModuleList.TIME_MANAGEMENT, PermissionList.MODULE_ZEW_ABSENCES),
			],
		},
	},
	{
		name: "addAbsence",
		path: "modules/zew/absences/add",
		component: () => import("@/views/modules/zeitwirtschaft/absences/AddAbsencePage.vue"),
		meta: {
			middleware: [
				new AuthMiddleware(),
				new ModuleMiddleware(ModuleList.TIME_MANAGEMENT),
				new UserAuthMiddleware(ModuleList.TIME_MANAGEMENT, PermissionList.MODULE_ZEW_ABSENCES_ADD),
			],
		},
	},
	/*----- expenses -----*/
	{
		name: "expenses",
		path: "modules/zew/expenses",
		component: () => import("@/views/modules/zeitwirtschaft/expenses/ExpensePage.vue"),
		meta: {
			middleware: [
				new AuthMiddleware(),
				new ModuleMiddleware(ModuleList.TIME_MANAGEMENT),
				new UserAuthMiddleware(ModuleList.TIME_MANAGEMENT, PermissionList.MODULE_ZEW_EXPENSES),
			],
		},
	},
	{
		name: "addExpense",
		path: "modules/zew/expenses/add",
		component: () => import("@/views/modules/zeitwirtschaft/expenses/AddExpensePage.vue"),
		meta: {
			middleware: [
				new AuthMiddleware(),
				new ModuleMiddleware(ModuleList.TIME_MANAGEMENT),
				new UserAuthMiddleware(ModuleList.TIME_MANAGEMENT, PermissionList.MODULE_ZEW_EXPENSES_ADD),
			],
		},
	},
];

export default moduleZewRoutings;
